import find from 'lodash/find'
import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import matchPath from 'services/resolver/match-path'
import { WithLazy } from 'components/App/Hydration'
import HistoryContext from 'components/Router/HistoryContext'
import {
  useApolloClient,
} from '@apollo/client'

export default function Router ({
  routes,
}) {
  const apolloClient = useApolloClient()
  const history = useContext(HistoryContext)
  const resolver = useSelector((state) => state.resolver)
  const location = resolver.get('location', {})
  const pathname = location.pathname || '/'
  const route = find(routes, ({ path }) => {
    if (!path) return false
    if (path === pathname || path === '*') return true
    return matchPath({ path, pathname })
  })
  return route ? (
    <WithLazy>
      {route.component({ location, history, apolloClient })}
    </WithLazy>
  ) : null
}
